angular.module("digitalLeasing.module").component("additionalGoodInfo", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/additionalGoodInfo/additionalGoodInfo.view.html",
    bindings: {
        model: "=", //elementToAdd
        addGoodIsOk: "&",
        addGoodIsNotOk: "&",
        leasingData: "=",
        customer: "=",
        initialTabIndex: "=",
        isM12: "=",
        completatoArc: "=",
        isSublocazione: "<"
    },
    controllerAs: "additionalGoodInfoCtrl",
    controller: AdditionalGoodInfoController
});

function AdditionalGoodInfoController(Sede,
    RiUserG,
    Residenza,
    Pf,
    $financialApiService,
    $timeout,
    $rootScope,
    $giuridicVersion
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            subjectReturned: false,
            options: ["AZIENDA", "PERSONA"],
            defaultOptions: "AZIENDA",
            owner: false,
            typeIndirizzo: "",
            flyProductType: false,
            sedeIsPresent: false,
            addressList: [],
            showSedeComponent: false,
            sedeConsegnaSelected: [],
            initialIndex: 0,
            digitalCustomerTab: 0,
            responseRestAddress: false
        }
        self.mapComuni = $rootScope.comuniMap;
        self.supportModel.initialIndex = self.initialTabIndex || 0;
        self.supportModel.digitalCustomerTab = self.supportModel.initialIndex + 2;

        if (self.leasingData.preventivo.prodotto.beneContratto.length > 0) {
            if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                self.leasingData.preventivo.prodotto.id === "NAV") {
                populateSede("flyNav");
                selectAddress("flyNav");
                if (self.leasingData.preventivo.prodotto.id === "FLY") {
                    self.supportModel.flyProductType = true
                } else {
                    self.model.flyNav.navale = true;
                }
            } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                populateSede("ferroviario");
                selectAddress("ferroviario");
            } else {
                populateSede("strumentale");
                selectAddress("strumentale");
            }
        }

        checkValidation();
    };

    self.handleChange = function (property, value, productType) {
        switch (property) {
            case "sedeLegale":
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {

                    self.model.flyNav.proprietarioImmobile.riUserG[property] = value;

                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.model.ferroviario.proprietarioImmobile.riUserG[property] = value;
                } else {
                    self.model.strumentale.proprietarioImmobile.riUserG[property] = value;
                }
                break;
            case "residenza":
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV" &&
                    self.model.flyNav.proprietarioImmobile.riUserF) {
                    self.model.flyNav.proprietarioImmobile.riUserF[property] = value;

                } else if (self.leasingData.preventivo.prodotto.id === "FER" &&
                    self.model.ferroviario.proprietarioImmobile.riUserF) {
                    self.model.ferroviario.proprietarioImmobile.riUserF[property] = value;

                } else if (self.model.strumentale.proprietarioImmobile.riUserF) {
                    self.model.strumentale.proprietarioImmobile.riUserF[property] = value;
                }
                break;
            case "sedeConsegna":
                self.supportModel.showSedeComponent = value.toponomastica === "NUOVO INDIRIZZO" ? true : false;

                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    populateSedeConsegna('flyNav', value);
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    populateSedeConsegna('ferroviario', value);
                } else {
                    populateSedeConsegna('strumentale', value);
                }
                break;
            case "address":
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    self.model.flyNav.proprietarioImmobile.riUserG.sedeConsegna = value;
                    self.model.flyNav.proprietarioImmobile.riUserG.sedeConsegna.isNewAddress = self.supportModel.showSedeComponent;
                    if (!self.model.flyNav.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo) {
                        self.model.flyNav.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo = "LEG";
                    }
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.model.ferroviario.proprietarioImmobile.riUserG.sedeConsegna = value;
                    self.model.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.isNewAddress = self.supportModel.showSedeComponent;
                    if (!self.model.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo) {
                        self.model.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo = "LEG";
                    }
                } else {
                    self.model.strumentale.proprietarioImmobile.riUserG.sedeConsegna = value;
                    self.model.strumentale.proprietarioImmobile.riUserG.sedeConsegna.isNewAddress = self.supportModel.showSedeComponent;
                    if (!self.model.strumentale.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo) {
                        self.model.strumentale.proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo = "LEG";
                    }
                }
                self.sedeConsegnaSelected = value;
                self.supportModel.sedeConsegnaSelected = value;
                self.supportModel.sedeConsegnaSelected.toponomastica = 'NUOVO INDIRIZZO';
                self.model.strumentale.proprietarioImmobile.sedeConsegna = value;
                break;
            case "clienteProprietarioImm":
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    populateProprietario(value, "flyNav");
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    populateProprietario(value, "ferroviario");
                } else {
                    populateProprietario(value, "strumentale");
                }
                break;
            case "cfPiva":
            case "ragSocNominativo":
                self.model[productType].proprietarioImmobile[property] = value;
                break;
            case "residenzaProprietarioImmobile":
                if (!value) {
                    self.model[productType].proprietarioImmobile[property] = null;
                }
            default:
                break;
        }

        checkValidation();
    }

    self.checkProductTypeGetSubject = function (productType, valueModel, value) {

        self.model[productType].proprietarioImmobile.isPersona = false;
        if (valueModel === "riUserF") {
            self.model[productType].proprietarioImmobile.isPersona = true;
            if (!self.model[productType].proprietarioImmobile.riUserF) {
                self.model[productType].proprietarioImmobile.riUserF = Pf.build();
            }

            self.model[productType].proprietarioImmobile.riUserF = Pf.build(value.riUserF);
            if (self.model[productType].proprietarioImmobile.riUserF &&
                !self.model[productType].proprietarioImmobile.riUserF.residenza) {
                self.model[productType].proprietarioImmobile.riUserF.residenza = value.riUserF.residenza;
            }
        } else if (valueModel === "riUserG") {
            if (!self.model[productType].proprietarioImmobile.riUserG) {
                self.model[productType].proprietarioImmobile.riUserG = RiUserG.build();
            }
            const updateSedeConsegna = self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.isNewAddress;
            var newSedeConsegna = {};
            if (updateSedeConsegna) {
                newSedeConsegna = Sede.build(self.model[productType].proprietarioImmobile.riUserG.sedeConsegna);
            }
            self.model[productType].proprietarioImmobile.riUserG = value.riUserG;
            if (updateSedeConsegna) {
                self.model[productType].proprietarioImmobile.riUserG.sedeConsegna = newSedeConsegna;
            }
            if (self.model[productType].proprietarioImmobile.riUserG &&
                !self.model[productType].proprietarioImmobile.riUserG.sedeLegale) {
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale = value.riUserG.sedeLegale;
            }
        }
    }

    self.resetObjGetSubject = function (productType, valueModel) {

        if (valueModel === 'riUserG') {
            self.sedeConsegna = self.model[productType].proprietarioImmobile[valueModel].sedeConsegna
            self.model[productType].proprietarioImmobile[valueModel] = RiUserG.build();
            self.model[productType].proprietarioImmobile[valueModel].sedeConsegna = self.sedeConsegna
            self.model[productType].proprietarioImmobile[valueModel].sedeLegale = null;
        } else {
            self.model[productType].proprietarioImmobile[valueModel] = {};
        }
    }

    self.typeIndirizzo = function (productType, modelValue, value, tipoIndirizzo) {

        if (self.sedeConsegna || self.supportModel.sedeConsegnaSelected) {
            self.supportModel.sedeConsegnaSelected.luogoEsteso = self.mapComuni.find(function (element) {
                if (element && element.nome) {
                    return element.nome.toUpperCase() == self.supportModel.sedeConsegnaSelected.comune.toUpperCase();
                }
            })
            self.sedeConsegna = self.supportModel.sedeConsegnaSelected;
            self.model[productType].proprietarioImmobile[modelValue] = value[modelValue];
            self.model[productType].proprietarioImmobile[modelValue].sedeConsegna = self.supportModel.sedeConsegnaSelected;
        } else {
            self.sedeConsegna = self.model[productType].proprietarioImmobile.riUserG.sedeConsegna;
            self.model[productType].proprietarioImmobile[modelValue] = value[modelValue];
        }

        //se il servizio restituisce la sedeConsegna vuota la popolo con il modello iniziale
        if (!self.model[productType].proprietarioImmobile.riUserG.sedeConsegna ||
            (self.model[productType].proprietarioImmobile.riUserG.sedeConsegna && !self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.indirizzo)) {
            self.model[productType].proprietarioImmobile.riUserG.sedeConsegna = self.sedeConsegna;
        }
        self.supportModel.typeIndirizzo = value;

        //se la forma giuridica è IND e il proprietario inserito non è censito,
        //popolo anche il riUserF 
        if (modelValue === "riUserG" &&
            $giuridicVersion.checkIfInd(self.model[productType].proprietarioImmobile.riUserG.formaGiuridica) &&
            value.riUserF) {
            self.model[productType].proprietarioImmobile.riUserF = value.riUserF;
        }
    }

    self.getSubject = function (value) {

        if (value) {
            self.supportModel.subjectReturned = false;
            if (value.riUserG) {
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    self.model.flyNav.proprietarioImmobile.isPersona = false;
                    self.checkProductTypeGetSubject('flyNav', 'riUserG', value);
                    self.typeIndirizzo('flyNav', 'riUserG', value, 'sedeLegale');
                    self.resetObjGetSubject('flyNav', 'riUserF');
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.model.ferroviario.proprietarioImmobile.isPersona = false;
                    self.checkProductTypeGetSubject('ferroviario', 'riUserG', value);
                    self.typeIndirizzo('ferroviario', 'riUserG', value, 'sedeLegale');
                    self.resetObjGetSubject('ferroviario', 'riUserF');
                } else {
                    self.model.strumentale.proprietarioImmobile.isPersona = false;
                    self.checkProductTypeGetSubject('strumentale', 'riUserG', value);
                    self.typeIndirizzo('strumentale', 'riUserG', value, 'sedeLegale');
                    if (value.riUserG.ndg && !$giuridicVersion.checkIfInd(value.riUserG.formaGiuridica)) {
                        self.resetObjGetSubject('strumentale', 'riUserF');
                    }
                }
            } else {
                self.model.strumentale.proprietarioImmobile.isPersona = true;
                if (self.model.strumentale.proprietarioImmobile.riUserF && self.model.strumentale.proprietarioImmobile.riUserF.cf != value.riUserF.cf) {
                    self.model.strumentale.proprietarioImmobile.riUserF = Pf.build();
                }
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    self.checkProductTypeGetSubject('flyNav', 'riUserF', value);
                    self.typeIndirizzo('flyNav', 'riUserF', value, 'residenza');
                    self.resetObjGetSubject('flyNav', 'riUserG');
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.checkProductTypeGetSubject('ferroviario', 'riUserF', value);
                    self.typeIndirizzo('ferroviario', 'riUserF', value, 'residenza');
                    self.resetObjGetSubject('ferroviario', 'riUserG');
                } else {
                    self.checkProductTypeGetSubject('strumentale', 'riUserF', value);
                    self.typeIndirizzo('strumentale', 'riUserF', value, 'residenza');
                    self.resetObjGetSubject('strumentale', 'riUserG')
                }
            }

            if (self.validityCustomerDigital) {
                self.supportModel.subjectReturned = true;
            }
            checkValidation();
        }
    }

    self.exportValidityCustomerDigital = function (validity) {
        if (self.model.strumentale || self.model.flyNav || self.model.ferroviario) {
            self.validityCustomerDigital = validity
            if (!validity) {
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    self.productTypeExportvalidityCustomerDigital('flyNav');
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.productTypeExportvalidityCustomerDigital('ferroviario');
                } else {
                    self.productTypeExportvalidityCustomerDigital('strumentale')
                }
            }
            checkValidation();
        }
    }

    self.productTypeExportvalidityCustomerDigital = function (productType) {
        if (!self.supportModel.sedeIsPresent) {
            if (self.model[productType].proprietarioImmobile.riUserG &&
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale && !Sede.build(self.model[productType].proprietarioImmobile.riUserG.sedeLegale).isOk(true)) {
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale = null;
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale = Sede.build();
            } else if (self.model[productType].proprietarioImmobile.riUserF &&
                self.model[productType].proprietarioImmobile.riUserF.residenza && !Sede.build(self.model[productType].proprietarioImmobile.riUserF.residenza).isOk(true)) {
                self.model[productType].proprietarioImmobile.riUserF.residenza = null;
                self.model[productType].proprietarioImmobile.riUserF.residenza = Residenza.build();
            }
        }
    }

    self.checkSingleAddress = function (productType, valueModel, sedeType) {
        if (self.isM12) {
            if (self.supportModel.sedeIsPresent) {
                self.test = verifySedeConsenga(productType);
            } else {
                self.test = true;
            }
        } else {
            if (self.supportModel.sedeIsPresent) {
                self.test = verifySedeConsenga(productType);
            } else {
                self.test = verifySedi(productType, valueModel, sedeType);
            }
        }
    }

    self.checkAllAddress = function (productType, element) {
        if (self.isM12) {
            if (self.supportModel.sedeIsPresent) {
                self.test = verifySedeConsenga(productType, element);
            } else {
                self.test = true;
            }
        } else {
            if (self.supportModel.sedeIsPresent) {
                self.test = verifySedeConsenga(productType, element);
            } else {
                self.test = verifySedi(productType, valueModel, sedeType, element);
            }
        }
    }

    self.productTypeCheckValidation = function (typeValue, sedeType) {
        if (self.leasingData.preventivo.prodotto.id === "FLY" ||
            self.leasingData.preventivo.prodotto.id === "NAV") {
            self.checkSingleAddress('flyNav', typeValue, sedeType);
        } else if (self.leasingData.preventivo.prodotto.id === "FER") {
            self.checkSingleAddress('ferroviario', typeValue, sedeType);
        } else {
            self.checkSingleAddress('strumentale', typeValue, sedeType);
        }
    }

    self.testProprietarioImmobile = function (productType) {

        if (self.model[productType].clienteProprietarioImm) {
            self.testProprietarioImm = true;
        } else {
            self.testProprietarioImm = false;
            if (self.isM12) {
                self.testProprietarioImm = self.model[productType].proprietarioImmobile.cfPiva &&
                    self.model[productType].proprietarioImmobile.ragSocNominativo;
            } else {
                self.testProprietarioImm = self.validityCustomerDigital;
            }
        }
    }

    self.testProprietarioImmobileElement = function (element, productType) {
        if (element[productType].clienteProprietarioImm) {
            self.testProprietarioImm = true;
        } else {
            self.testProprietarioImm = false;
            if (self.isM12) {
                self.testProprietarioImm = element[productType].proprietarioImmobile.cfPiva &&
                    element[productType].proprietarioImmobile.ragSocNominativo;
            } else {
                self.testProprietarioImm = self.validityCustomerDigital;
            }
        }
    }

    self.checkSede = function (isPresent) {
        self.supportModel.sedeIsPresent = isPresent;
    }

    var populateSede = function (productType) {
        self.productType = productType;
        if (typeof self.model[productType].clienteProprietarioImm == "undefined") {
            self.supportModel.subjectReturned = true;
            self.model[productType].clienteProprietarioImm = true;
            self.model[productType].proprietarioImmobile.riUserG.sedeLegale = self.customer.metadata.riUserG.sedeLegale;
            self.supportModel.typeIndirizzo = self.customer.metadata;
            self.supportModel.owner = true;
        } else {
            self.supportModel.owner = self.model[productType].clienteProprietarioImm;
        }

        if (!self.model[productType].proprietarioImmobile.isPersona) {
            self.supportModel.subjectReturned = true;
            self.supportModel.typeIndirizzo = self.model[productType].proprietarioImmobile;
            self.supportModel.typeIndirizzo.riUserG.cf = self.supportModel.typeIndirizzo && self.supportModel.typeIndirizzo.cfPiva ? self.supportModel.typeIndirizzo.cfPiva : self.supportModel.typeIndirizzo.riUserG.cf;
            if ((!$giuridicVersion.checkIfInd(self.supportModel.typeIndirizzo.riUserG.formaGiuridica)) || ($giuridicVersion.checkIfInd(self.supportModel.typeIndirizzo.riUserG.formaGiuridica) && !self.supportModel.typeIndirizzo.riUserG.pIvaAssente && (self.supportModel.typeIndirizzo.riUserF && self.supportModel.typeIndirizzo.riUserF.residenza && !Sede.build(self.supportModel.typeIndirizzo.riUserF.residenza).isOk(true)))) {
                self.supportModel.typeIndirizzo.riUserF = null;
            }

        } else if (self.model[productType].proprietarioImmobile.isPersona) {
            self.supportModel.subjectReturned = true;
            self.supportModel.typeIndirizzo = self.model[productType].proprietarioImmobile;
        }

        //da verificare se è un caso sporco piva 01668440850
        if (self.model[productType].proprietarioImmobile.riUserG.sedeLegale && self.model[productType].proprietarioImmobile.riUserG.sedeLegale.comune && !self.model[productType].proprietarioImmobile.riUserG.sedeLegale.indirizzo) {
            self.customer.metadata.riUserG.sedeLegale = self.customer.metadata.riUserG.sedeConsegna;
        }
    }

    var checkValidation = function () {
        self.test = false;
        self.testProprietarioImm = false;

        if (self.model.idBene) {
            var typeValue = self.model[self.productType].proprietarioImmobile.riUserG.sedeLegale ? 'riUserG' : 'riUserF'
            var sedeType = typeValue === 'riUserG' ? 'sedeLegale' : 'residenza';
            self.productTypeCheckValidation(typeValue, sedeType);
            self.testProprietarioImmobile(self.productType);
        } else {
            self.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
                self.testProprietarioImmobileElement(element, self.productType);
                if (self.leasingData.preventivo.prodotto.id === "FLY" ||
                    self.leasingData.preventivo.prodotto.id === "NAV") {
                    self.checkAllAddress("flyNav", element);
                } else if (self.leasingData.preventivo.prodotto.id === "FER") {
                    self.checkAllAddress("ferroviario", element);
                } else {
                    self.checkAllAddress("strumentale", element);
                }
            });
        }

        if (self.test && self.testProprietarioImm) {
            self.addGoodIsOk();
        } else {
            self.addGoodIsNotOk();
        }
    }

    var populateProprietario = function (value, productType) {
        self.supportModel.subjectReturned = false;
        self.model[productType].clienteProprietarioImm = value;

        if (self.model[productType].clienteProprietarioImm) {
            self.model[productType].proprietarioImmobile.riUserG.sedeLegale = self.customer.metadata.riUserG.sedeLegale;
            self.supportModel.subjectReturned = true;
            self.supportModel.sedeIsPresent = false;
            if (self.model[productType].proprietarioImmobile.riUserG.sedeLegale.comune == null) {
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale.comune = self.model[productType].proprietarioImmobile.riUserG.sedeLegale.luogoEsteso.nome
            }
            if (!$giuridicVersion.checkIfInd(self.customer.metadata.riUserG.formaGiuridica)) {
                self.model[productType].proprietarioImmobile.riUserF = {}
            }

            self.model[productType].proprietarioImmobile.cfPiva = "";
            self.model[productType].proprietarioImmobile.ragSocNominativo = "";
        } else {
            self.supportModel.indProprietarioImm = Sede.build();
            if (self.model[productType].proprietarioImmobile.riUserG) {
                self.model[productType].proprietarioImmobile.riUserG.sedeLegale = Sede.build();
            }
            if (self.model[productType].proprietarioImmobile.riUserF) {
                self.model[productType].proprietarioImmobile.riUserF.residenza = Residenza.build();
            } else {
                self.model[productType].proprietarioImmobile.riUserF = {}
            }
            self.supportModel.typeIndirizzo = null;
        }
    }

    var selectAddress = function (productType) {

        if (self.model[productType].proprietarioImmobile.riUserG.sedeConsegna &&
            self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.indirizzo) {
            self.supportModel.sedeConsegnaSelected = self.model[productType].proprietarioImmobile.riUserG.sedeConsegna;
            self.model[productType].indirizzoImmobile = self.model[productType].proprietarioImmobile.riUserG.sedeConsegna;

            if (self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.isNewAddress) {
                self.supportModel.showSedeComponent = true;
                self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.toponomastica = "NUOVO INDIRIZZO";
            }
        }

        $timeout(function () {
            $financialApiService
                .searchAddress(self.customer.metadata.riUserG.ndg)
                .then(function (addressResponse) {
                    self.supportModel.addressList = addressResponse.nsilAddresses;
                    self.supportModel.addressList.push({
                        toponomastica: "NUOVO INDIRIZZO"
                    });

                    if (!self.supportModel.sedeConsegnaSelected.cdTipoIndirizzo) {
                        self.supportModel.addressList.forEach(function (addressSelected) {
                            if (addressSelected.cdTipoIndirizzo === "LEG") {
                                self.supportModel.sedeConsegnaSelected = addressSelected;
                            }
                        });
                    }
                    self.model[productType].indirizzoImmobile = self.supportModel.sedeConsegnaSelected;
                    populateSedeConsegna(productType, self.supportModel.sedeConsegnaSelected);
                    //populateSedeLegale(productType, self.supportModel.sedeConsegnaSelected)
                }).catch(function (error) {
                    console.log(error);
                });
        }, 1000)
    }

    var populateSedeLegale = function (productType, value) {
        value.stato.name = value.stato.name.toUpperCase();
        self.model[productType].proprietarioImmobile.riUserG.sedeLegale = Sede.build(value);
        self.model[productType].proprietarioImmobile.riUserG.sedeLegale.luogoEsteso.nome = value.comune;
        self.model[productType].proprietarioImmobile.riUserG.sedeLegale.luogoEsteso.sigla = value.provincia;
        self.supportModel.responseRestAddress = true;
    }

    var populateSedeConsegna = function (productType, value) {
        self.model[productType].proprietarioImmobile.riUserG.sedeConsegna = Sede.build(value);
        // self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.luogoEsteso.nome = value.comune;
        // self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.luogoEsteso.sigla = value.provincia;
        // self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.luogoEsteso.cap[0] = value.cap;

        // parte nuova sostituisce le tre righe superiori
        self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.luogoEsteso = self.mapComuni.find(function (element) {
            return element.nome.toUpperCase() == value.comune.toUpperCase()
        })

        if (!self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo) {
            self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.cdTipoIndirizzo = "LEG";
        }

        if (self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.isNewAddress) {
            self.model[productType].proprietarioImmobile.riUserG.sedeConsegna.toponomastica = null;
        }
        self.model[productType].indirizzoImmobile = self.model[productType].proprietarioImmobile.riUserG.sedeConsegna;
        checkValidation();
    }

    var verifySedeConsenga = function (productType, element) {
        var modello = "";
        if (element != null) {
            modello = element;
            if ([modello][productType].proprietarioImmobile.riUserG.sedeConsegna &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.stato && [modello][productType].proprietarioImmobile.riUserG.sedeConsegna.stato.value && [modello][productType].proprietarioImmobile.riUserG.sedeConsegna.indirizzo && [modello][productType].proprietarioImmobile.riUserG.sedeConsegna.numeroCivico && [modello][productType].proprietarioImmobile.riUserG.sedeConsegna.provincia && [modello][productType].proprietarioImmobile.riUserG.sedeConsegna.cap) {
                return true;
            } else {
                return false;
            }

        } else {
            modello = self.model;
            if (modello[productType].proprietarioImmobile.riUserG.sedeConsegna &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.stato &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.stato.value &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.indirizzo &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.numeroCivico &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.provincia &&
                modello[productType].proprietarioImmobile.riUserG.sedeConsegna.cap) {
                return true;
            } else {
                return false;
            }
        }
    }

    var verifySedi = function (productType, valueModel, sedeType, element) {
        var modello = "";
        if (element != null) {
            modello = element;
        } else {
            modello = self.model;
        }
        if (modello[productType].proprietarioImmobile[valueModel] &&
            modello[productType].proprietarioImmobile[valueModel][sedeType].stato.name &&
            modello[productType].proprietarioImmobile[valueModel][sedeType].indirizzo &&
            modello[productType].proprietarioImmobile[valueModel][sedeType].provincia &&
            modello[productType].proprietarioImmobile[valueModel][sedeType].comune &&
            modello[productType].proprietarioImmobile[valueModel][sedeType].numeroCivico &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna.stato.value &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna.indirizzo &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna.numeroCivico &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna.provincia &&
            modello[productType].proprietarioImmobile.riUserG.sedeConsegna.cap) {
            return true;
        } else {
            return false;
        }
    }
}